import { BasketType } from "@prisma/client";

export const basketQueryKeys = {
  all: ["basket"] as const,
  get: (type: BasketType) => [...basketQueryKeys.all, "get", type] as const,
  getById: (id: string) => [...basketQueryKeys.all, "getById", id] as const,
  activityWarning: () => [...basketQueryKeys.all, "activity-warning"] as const,
};
